import React, { useEffect, useState } from "react";
import "./App.css";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal2);

function App() {
  const [password, setPassword] = useState("");
  const [formData, setFormData] = useState({
    street: "",
    building: "",
    postalCode: "",
    municipality: "",
    parcelNo: "",
    obreb: "", // <-- NOWE
    name: "",
    phone: "",
    mail: "",
  });
  const [searchByParcel, setSearchByParcel] = useState(false);
  const [pp, setPP] = useState(true);
  const [loading, setLoading] = useState(false);
  const [countdown, setCountdown] = useState(0); // <-- NOWE
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const MIN_WAIT_MS = 90_000;

  // <-- NOWE: odliczanie w dół podczas ładowania
  useEffect(() => {
    if (!loading) {
      setCountdown(0);
      return;
    }

    setCountdown(90);
    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [loading]);

  useEffect(() => {
    if (searchByParcel) {
      setFormData((prev) => ({
        ...prev,
        street: "",
        building: "",
        postalCode: "",
      }));
    }
  }, [searchByParcel]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const generateCode = () => {
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < 5) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  };

  const sendSMSCode = async (code) => {
    var body = {
      phone: formData.phone,
      message: `Wprowadź kod: ${code} by dokończyć generowanie analizy Twojej działki.`,
    };

    await fetch("https://apisluzebnosc.ftpeople.pl/send_sms", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        console.log(data);
      })
      .catch((error) => {});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // walidacja minimalna
    if (!formData.municipality?.trim() || !formData.parcelNo?.trim()) {
      setError("Podaj miejscowość oraz numer działki.");
      return;
    }

    if (!searchByParcel) {
      if (
        !formData.street?.trim() ||
        !formData.building?.trim() ||
        !formData.postalCode?.trim()
      ) {
        setError(
          "Podaj ulicę, nr domu i kod pocztowy (albo zaznacz wyszukiwanie po działce)."
        );
        return;
      }
    }

    setLoading(true);
    setError(null);
    setResult(null);

    const code = generateCode();
    sendSMSCode(code);

    MySwal.fire({
      input: "text",
      inputLabel: "wprowadź kod otrzymany w SMS",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      confirmButtonText: "Wygeneruj analizę",
      iconColor: "#cdad7d",
      buttonsStyling: false,
      customClass: {
        popup: "swal-glass",
        title: "swal-title",
        htmlContainer: "swal-text",
        input: "swal-input",
        confirmButton: "swal-btn swal-btn--confirm",
        cancelButton: "swal-btn swal-btn--cancel",
        actions: "swal-actions",
      },
      inputValidator: (value) => {
        if (value !== code) return "wprowadzony kod jest nieprawidłowy";
      },
    }).then((result) => {
      if (result.isConfirmed) sendData();
      else setLoading(false); // jeśli anulował, to wyłącz loader
    });
  };

  const sendSplitter = async (result) => {
    const secretKey = "FtPeople@)24!";
    const url = "https://apiftpsplit.ftpeople.pl/addLead";

    const data = {
      name: formData.name,
      phone: formData.phone,
      mail: formData.mail,
      source: "ILEZASLUP CALC",
      idSource: "",
      linkSource: "",
      auto: "1",
      note: `dane analizy: ${result.url}`,
      company: "SLUZEBNOSC",
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(data),
      });

      const responseData = await response.json();

      console.log("Status:", response.status);
      console.log("Odpowiedź API:", responseData);
    } catch (error) {
      console.error("Błąd:", error);
    }
  };

  const sendData = async () => {
    window.fbq?.("trackCustom", "contactIZS");
    window.gtag?.("event", "conversion", {
      send_to: "AW-16454383293/58BICJCo5_EbEL3th6Y9",
      value: 1.0,
      currency: "PLN",
    });

    const startedAt = Date.now();

    const payload = searchByParcel
      ? {
          municipality: formData.municipality,
          parcelNo: formData.parcelNo,
          obreb: formData.obreb,
          name: formData.name,
          phone: formData.phone,
          mail: formData.mail,
          mode: "parcel",
          half: 100,
        }
      : {
          ...formData,
          mode: "address",
          half: 100,
        };

    try {
      const response = await fetch("https://apisluzebnosc.ftpeople.pl/mapka", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!response.ok)
        throw new Error("Błąd serwera. Spróbuj ponownie za chwilę.");

      const data = await response.json();

      const elapsed = Date.now() - startedAt;
      const remaining = Math.max(0, MIN_WAIT_MS - elapsed);
      if (remaining > 0)
        await new Promise((resolve) => setTimeout(resolve, remaining));

      sendSplitter(data);
      setResult(data);
    } catch (err) {
      const elapsed = Date.now() - startedAt;
      const remaining = Math.max(0, MIN_WAIT_MS - elapsed);
      if (remaining > 0)
        await new Promise((resolve) => setTimeout(resolve, remaining));

      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const formatPLN = (val) =>
    new Intl.NumberFormat("pl-PL", {
      style: "currency",
      currency: "PLN",
      maximumFractionDigits: 0,
    }).format(val);

  // --- GŁÓWNA APLIKACJA ---
  return (
    <>
      <section className="input-section">
        <form onSubmit={handleSubmit} className="glass-card">
          <div className="input-row">
            <div className="field">
              <label className="checkbox">
                <input
                  type="checkbox"
                  checked={searchByParcel}
                  onChange={(e) => setSearchByParcel(e.target.checked)}
                />
                Nie znam numeru domu – wyszukaj po działce
              </label>
            </div>
          </div>
          <div className="input-row">
            <div className="field">
              <label>Ulica</label>
              <input
                name="street"
                value={formData.street}
                onChange={handleChange}
                placeholder="Główna"
                required={!searchByParcel}
              />
            </div>
            {!searchByParcel ? (
              <div className="field short">
                <label>Nr domu </label>
                <input
                  name="building"
                  value={formData.building}
                  onChange={handleChange}
                  placeholder="10"
                  required={!searchByParcel}
                />
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="input-row">
            <div className="field short">
              <label>Kod pocztowy</label>
              <input
                name="postalCode"
                value={formData.postalCode}
                onChange={handleChange}
                placeholder="00-000"
                required={!searchByParcel}
              />
            </div>
            <div className="field">
              <label>Miejscowość</label>
              <input
                name="municipality"
                value={formData.municipality}
                onChange={handleChange}
                placeholder="Wrocław"
                required
              />
            </div>
          </div>
          <div className="field">
            <label>Numer Działki</label>
            <input
              name="parcelNo"
              value={formData.parcelNo}
              onChange={handleChange}
              placeholder="np. 123/4"
              required
            />
          </div>
          {searchByParcel && (
            <div className="field">
              <label>Obręb ewidencyjny (opcjonalnie)</label>
              <input
                name="obreb"
                value={formData.obreb}
                onChange={handleChange}
                placeholder="np. Krzyki, Nowa Wieś"
              />
              <span className="span_info">
                (Jeżeli wyników jest kilka, obręb pomaga jednoznacznie znaleźć
                działkę)
              </span>
            </div>
          )}

          <div className="input-row">
            <div className="field">
              <label>Imię i nazwisko</label>
              <input
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Jan Kowalski"
                required
              />
            </div>
            <div className="field">
              <label>Numer telefonu</label>
              <input
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="123 123 123"
                required
              />
            </div>
            <div className="field">
              <label>Adres e-mail</label>
              <input
                name="mail"
                value={formData.mail}
                onChange={handleChange}
                placeholder="jan@kowalski.pl"
                required
              />
            </div>
          </div>
          <div className="input-row">
            <div className="field">
              <label className="checkbox" id="checkPol">
                <input
                  type="checkbox"
                  checked={pp}
                  onChange={(e) => setPP(e.target.checked)}
                  required
                />
                zapoznałem/-am się z
                <a
                  href="https://ilezaslup.pl/polityka-prywatnosci/"
                  target="_blank"
                  style={{ paddingRight: "2px", paddingLeft: "2px" }}
                >
                  polityką prywatności
                </a>
                i akceptuję jej postanowienia.
              </label>
            </div>
          </div>

          <button className="submit-button" disabled={loading}>
            {loading ? (
              <>
                <span className="spinner"></span>{" "}
                {countdown > 0
                  ? `Trwa generowanie analizy... (${countdown}s)`
                  : "Kończymy obliczenia…"}
              </>
            ) : (
              "Generuj Raport"
            )}
          </button>
        </form>
        {error && <div className="error-msg">{error}</div>}
      </section>

      {result && result.analysis && (
        <section className="results-container">
          <div className="grid-top">
            <div className="card map-preview">
              <div className="card-header">Mapa Katastralna</div>
              <a href={result.url} target="_blank" rel="noreferrer">
                <img src={result.url} alt="Mapa WMS" />
              </a>
              <div className="address-tag">{result.fullAddress}</div>
            </div>

            <div className="card technical-info">
              <div className="card-header">Analiza Techniczna</div>
              <div className="parcel-id">
                Działka: <strong>{result.analysis.działka}</strong>
              </div>
              <p className="desc-text">{result.analysis.analiza_techniczna}</p>
              <div className="reasoning-box">
                <h4>Uzasadnienie współczynnika K:</h4>
                <p>{result.analysis.parametry_wyceny.wyjasnienie_k}</p>
              </div>
            </div>
          </div>

          <div className="card valuation-params">
            <div className="card-header">Parametry Przyjęte do Obliczeń</div>
            <div className="metrics-grid">
              <div className="metric">
                <label>Cena gruntu</label>
                <span>
                  {result.analysis.parametry_wyceny.szacowana_cena_m2_gruntu}{" "}
                  zł/m²
                </span>
              </div>
              <div className="metric">
                <label>Szerokość strefy</label>
                <span>
                  {result.analysis.parametry_wyceny.przyjeta_szerokosc_strefy_m}{" "}
                  m
                </span>
              </div>
              <div className="metric">
                <label>Pow. strefy</label>
                <span>
                  {
                    result.analysis.parametry_wyceny
                      .powierzchnia_strefy_zajetej_m2
                  }{" "}
                  m²
                </span>
              </div>
              <div className="metric">
                <label>Pow. działki</label>
                <span>
                  {
                    result.analysis.parametry_wyceny
                      .powierzchnia_calej_dzialki_m2
                  }{" "}
                  m²
                </span>
              </div>
              <div className="metric highlight">
                <label>Współczynnik K</label>
                <span>{result.analysis.parametry_wyceny.wspolczynnik_k}</span>
              </div>
            </div>
            <div className="method-explanation">
              <strong>Metodyka określenia wartości:</strong>{" "}
              {result.analysis.metoda_wyceny_m2}
            </div>
          </div>

          <div className="claims-section">
            {Object.entries(result.analysis.roszczenia).map(([key, value]) => (
              <div className="claim-card" key={key}>
                <div className="claim-header">
                  <span className="claim-title">{key.replace(/_/g, " ")}</span>
                  <span className="claim-formula">
                    Wzór: <code>{value.wzor}</code>
                  </span>
                </div>
                <div className="claim-amount">{formatPLN(value.kwota)}</div>
                <p className="claim-desc">{value.opis}</p>
              </div>
            ))}
          </div>

          <div className="total-summary">
            <div className="total-label">
              Łączna kwota roszczeń (szacunkowa):
            </div>
            <div className="total-value">
              {formatPLN(result.analysis.suma_total)}
            </div>
          </div>
        </section>
      )}
    </>
  );
}

export default App;
